export default "__VITE_ASSET__a5124d30__"